import { ParamGeneralStatus } from '@/types';
import { createStore, withProps, Store } from '@ngneat/elf';
import { SelectOption } from '@/components/form-builder/form-builder.types';

export interface DynaDocsModelStatusDto {
  dynaDocsModelId?: number;
  paramGeneralStatus?: ParamGeneralStatus;
}

export interface DynaDocsModelStatusProps {
  dto: DynaDocsModelStatusDto;
  errors: Record<string, string[]>;
  dynaDocsModelSelected?: SelectOption;
  statusSelected?: SelectOption;
}

export const getDynaDocsModelStatusInitialState = (): DynaDocsModelStatusProps => ({
  dto: {
    dynaDocsModelId: undefined,
    paramGeneralStatus: ParamGeneralStatus.ACTIF,
  },
  errors: {},
});

export const dynaDocsModelStatusStoreFactory = (id: string) =>
  createStore({ name: `dyna-docs-model-status-${id}` }, withProps<DynaDocsModelStatusProps>(getDynaDocsModelStatusInitialState()));

export type DynaDocsModelStatusStoreType = ReturnType<typeof dynaDocsModelStatusStoreFactory>;

export type DynaDocsModelStatusStore = Store<
  {
    name: string;
    state: DynaDocsModelStatusProps;
    config: undefined;
  },
  DynaDocsModelStatusProps
>;
